import React from "react";
import { BATTLEKART_ENABLED } from "@/consts/featureFlags";

/**
 * Route screens loaded after the first booking step.
 *
 * TrackSelection and RacingTrackSelection stay eager in Router.tsx so `/` and
 * `/tracks` paint from the main bundle. Everything past that is a dynamic
 * import: webpack emits a chunk, and Shopify still only references bundle.js
 * because chunk URLs are resolved at runtime against the origin bundle.js was
 * served from (see the "auto" publicPath in config/webpack.config.js).
 *
 * webpackChunkName keeps the files readable in the build output; the hash in
 * chunkFilename still cache-busts them.
 */
const lazyScreen = (importer: () => Promise<{ default: React.ComponentType }>) => React.lazy(importer);

export const SelectSeatsRaces = lazyScreen(() => import(/* webpackChunkName: "screen-main-seats" */ "@/components/MainTrack/subComponents/SelectSeatsRaces"));
export const SelectDateTime = lazyScreen(() => import(/* webpackChunkName: "screen-main-date" */ "@/components/MainTrack/subComponents/SelectDateTime"));
export const ReviewExperience = lazyScreen(() => import(/* webpackChunkName: "screen-main-summary" */ "@/components/MainTrack/subComponents/ReviewExperience"));
export const MainPostCode = lazyScreen(() => import(/* webpackChunkName: "screen-main-location" */ "@/components/MainTrack/subComponents/PostCode"));

export const IntermediateTrackSelectSeatsRaces = lazyScreen(
  () => import(/* webpackChunkName: "screen-intermediate-seats" */ "@/components/IntermediateTrack/subComponents/SelectSeatsRaces"),
);
export const IntermediateTrackSelectDateTime = lazyScreen(
  () => import(/* webpackChunkName: "screen-intermediate-date" */ "@/components/IntermediateTrack/subComponents/SelectDateTime"),
);
export const IntermediateTrackReviewExperience = lazyScreen(
  () => import(/* webpackChunkName: "screen-intermediate-summary" */ "@/components/IntermediateTrack/subComponents/ReviewExperience"),
);
export const IntermediateTrackPostCode = lazyScreen(
  () => import(/* webpackChunkName: "screen-intermediate-location" */ "@/components/IntermediateTrack/subComponents/PostCode"),
);

export const MiniSelectSeatsRaces = lazyScreen(() => import(/* webpackChunkName: "screen-mini-seats" */ "@/components/MiniTrack/subComponents/SelectSeatsRaces"));
export const MiniSelectDateTime = lazyScreen(() => import(/* webpackChunkName: "screen-mini-date" */ "@/components/MiniTrack/subComponents/SelectDateTime"));
export const MiniReviewExperience = lazyScreen(() => import(/* webpackChunkName: "screen-mini-summary" */ "@/components/MiniTrack/subComponents/ReviewExperience"));
export const MiniPostCode = lazyScreen(() => import(/* webpackChunkName: "screen-mini-location" */ "@/components/MiniTrack/subComponents/PostCode"));

export const JuniorTrackSelectSeatsRaces = lazyScreen(
  () => import(/* webpackChunkName: "screen-junior-seats" */ "@/components/JuniorTrack/subComponents/SelectSeatsRaces"),
);
export const JuniorTrack = lazyScreen(() => import(/* webpackChunkName: "screen-junior-date" */ "@/components/JuniorTrack"));
export const JuniorTrackReviewExperience = lazyScreen(
  () => import(/* webpackChunkName: "screen-junior-summary" */ "@/components/JuniorTrack/subComponents/ReviewExperience"),
);
export const JuniorTrackPostCode = lazyScreen(() => import(/* webpackChunkName: "screen-junior-location" */ "@/components/JuniorTrack/subComponents/PostCode"));

export const BattleKartPlayersAndSessions = BATTLEKART_ENABLED
  ? lazyScreen(() => import(/* webpackChunkName: "screen-battlekart-players" */ "@/components/battleKart/subComponents/playersAndSessions"))
  : () => null;
export const BattleKart = BATTLEKART_ENABLED
  ? lazyScreen(() => import(/* webpackChunkName: "screen-battlekart-date" */ "@/components/battleKart"))
  : () => null;
export const BattleKartPostCode = BATTLEKART_ENABLED
  ? lazyScreen(() => import(/* webpackChunkName: "screen-battlekart-location" */ "@/components/battleKart/subComponents/PostCode"))
  : () => null;

export const ArcadeCard = lazyScreen(() => import(/* webpackChunkName: "screen-arcade-card" */ "@/components/Arcade/SelectArcadeCard"));
export const ArcadeExperience = lazyScreen(() => import(/* webpackChunkName: "screen-arcade-experience" */ "@/components/Arcade/ReviewExperience"));
export const ArcadeCart = lazyScreen(() => import(/* webpackChunkName: "screen-arcade-cart" */ "@/components/Arcade/ReviewCart"));

export const AddAnotherAttraction = lazyScreen(() => import(/* webpackChunkName: "screen-extras" */ "@/components/AddAnotherAttraction"));

/** Holds the page height while a screen chunk loads so the footer does not jump. */
export const ScreenFallback: React.FC = () => <div aria-hidden className="tw-min-h-[50vh]" />;
